import { Overlay, OverlayModule as OverlayModule$1 } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/overlay';
const ONEP_OVERLAY_CLASS = new InjectionToken('ONEP_OVERLAY_CLASS');

class OverlayService {
    constructor(overlay, overlayClass) {
        this.overlay = overlay;
        this.overlayClass = overlayClass;
        this.scrollStrategies = this.overlay.scrollStrategies;
    }
    position() {
        return this.overlay.position();
    }
    create(config) {
        const extraClasses = this.overlayClass != null ? [this.overlayClass] : [];
        const classes = config.panelClass
            ? Array.isArray(config.panelClass)
                ? config.panelClass
                : [config.panelClass]
            : [];
        return this.overlay.create(Object.assign(Object.assign({}, config), { panelClass: [...classes, ...extraClasses] }));
    }
}
OverlayService.ɵfac = function OverlayService_Factory(t) { return new (t || OverlayService)(ɵngcc0.ɵɵinject(ɵngcc1.Overlay), ɵngcc0.ɵɵinject(ONEP_OVERLAY_CLASS, 8)); };
OverlayService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OverlayService, factory: OverlayService.ɵfac });
OverlayService.ctorParameters = () => [
    { type: Overlay },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ONEP_OVERLAY_CLASS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Overlay }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [ONEP_OVERLAY_CLASS]
            }] }]; }, null); })();

class OverlayModule {
    static forRoot() {
        return {
            ngModule: OverlayModule,
            providers: [OverlayService]
        };
    }
}
OverlayModule.ɵfac = function OverlayModule_Factory(t) { return new (t || OverlayModule)(); };
OverlayModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OverlayModule });
OverlayModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, OverlayModule$1] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule, OverlayModule$1]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OverlayModule, { imports: function () { return [CommonModule, OverlayModule$1]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ONEP_OVERLAY_CLASS, OverlayModule, OverlayService };

